var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco4Gflota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_55",
    "data-name": "Grupo 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.143,
    height: 31.592,
    viewBox: "0 0 20.143 31.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_51",
    "data-name": "Rect\\xE1ngulo 51",
    width: 20.143,
    height: 31.592,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55-2",
    "data-name": "Grupo 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M17.152,17.236h.01L10.1,24.3,3.375,17.576a10.065,10.065,0,1,1,13.778-.339M4.749,10.11A5.412,5.412,0,1,0,10.163,4.7,5.414,5.414,0,0,0,4.749,10.11",
    transform: "translate(-0.005 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_48",
    "data-name": "Rect\\xE1ngulo 48",
    width: 4.638,
    height: 4.638,
    transform: "translate(0 26.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_49",
    "data-name": "Rect\\xE1ngulo 49",
    width: 4.638,
    height: 4.638,
    transform: "translate(7.754 26.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_50",
    "data-name": "Rect\\xE1ngulo 50",
    width: 4.638,
    height: 4.638,
    transform: "translate(15.505 26.955)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4Gflota);
export default __webpack_public_path__ + "static/media/ico_4gflota.135db3a6fa5870dcfd4ad2a1cfbe8afd.svg";
export { ForwardRef as ReactComponent };